export const clickOnKeyUp = (evt) => {
  (evt.key === 'Enter' || evt.key === ' ') && evt.target.click();
};
